import React, { FC, useState } from 'react';
import BookViewer from '../../bookViewer/BookViewer';
import DevPage from '../../devTools/devPage/DevPage';
import ElectionViewer from '../../devTools/electionViewer/ElectionViewer';
import EventViewerPage from '../../eventViewer/EventViewerPage';
import FieldViewer from '../../fieldViewer/FieldViewer';
import ModificationViewer from '../../modificationViewer/ModificationViewer';
import SettingsPage from '../../settingsPage/SettingsPage';
import { TeamScatterPlots } from '../../teamScatterplots/TeamScatterPlots';
import TeamViewer from '../../teamViewer/TeamViewer';
import TeamWinsCharts from '../../teamWinsCharts/TeamWinsCharts';
import WinsOver500 from '../../winsOver500/WinsOver500';
import ViewSelector from '../viewSelector/ViewSelector';

import './Navigator.scss';

type StatsPages = "ScatterPlots" | "SimpleWins" | "TeamDetails" | "ModificationViewer"
type ComplexViz = "WinsOver500" | "FieldChart"
type Other = "Settings" | "EventViewer"

type DevPages = "DevPage" | "ElectionViewer"
type FKPages = "ForbiddenBook"

export type ViewType = StatsPages | ComplexViz | DevPages | FKPages | Other


const Navigator: FC = () => {

    function selectView(viewType: ViewType) {
        switch (viewType) {
            case "ScatterPlots": return <TeamScatterPlots />
            case "SimpleWins": return <TeamWinsCharts />
            case "TeamDetails": return <TeamViewer />
            case "FieldChart": return <FieldViewer />
            case "DevPage": return <DevPage />
            case "ModificationViewer": return <ModificationViewer />
            case "Settings": return <SettingsPage />
            case "ForbiddenBook": return <BookViewer />
            case "WinsOver500": return <WinsOver500 />
            case "ElectionViewer": return <ElectionViewer />
            case "EventViewer": return <EventViewerPage />
            default: return <div>Mode {viewType} not yet implemented</div>
        }
    }
    const [view, setView] = useState<ViewType>("SimpleWins")
    return <>
        <nav className="navigation">
            <ViewSelector setter={setView} currentView={view} />
        </nav>
        <div className="mainBody">
            {
                selectView(view)
            }

        </div>
    </>
}

export default Navigator;